import React from 'react'
import { Skeleton } from '@fs/zion-ui'
import MergeSquareCardMarginBox from '../../../../merge-common/layout/MergeSquareCardMarginBox'
import { personTypeMap } from '../../../../merge-common/helpers'
import { type PersonType } from '../../../../merge-common/types/general'

type Props = {
  personType: PersonType
}

/** A single vital conclusion (label + value) while loading. Mirrors ConclusionItem, including its per-column background color. */
export default function ConclusionItemSkeleton({ personType }: Props): JSX.Element {
  return (
    <div style={{ backgroundColor: personTypeMap[personType].cardBackgroundColor }}>
      <MergeSquareCardMarginBox>
        <Skeleton.ListItem hasSecondLine />
      </MergeSquareCardMarginBox>
    </div>
  )
}
